import ShadowContainer from "../../../components/common/ShadowContainer";
import ProductSearchDropdown from "./ProductSearchDropdown";

const inputClass =
  "w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-xl text-sm text-black placeholder-gray-400 focus:outline-none focus:border-black focus:bg-white transition-all duration-200";

const labelClass =
  "block text-xs font-semibold text-gray-500 uppercase tracking-widest mb-1.5";

const FieldGroup = ({ label, children }) => (
  <div>
    <label className={labelClass}>{label}</label>
    {children}
  </div>
);

const BannerForm = ({
  bannerData,
  handleImageChange,
  handleChange,
  handleSubmit,
  productSearch,
  productResults,
  loadingProducts,
  handleProductInputChange,
  handleSelectProduct,
}) => (
  <ShadowContainer maxWidth="max-w-4xl" padding="p-6">
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {/* Left — Image */}
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-2 pb-3 border-b border-gray-100">
            <div className="w-7 h-7 rounded-lg bg-black flex items-center justify-center text-white flex-shrink-0">
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-sm font-semibold text-gray-800">Banner Image</h3>
          </div>

          <FieldGroup label="Upload Image">
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              className="block w-full text-sm text-gray-600 file:mr-3 file:py-1.5 file:px-3 file:rounded-lg file:border-0 file:text-xs file:font-semibold file:bg-blue-600 file:text-white hover:file:bg-blue-700 cursor-pointer"
            />
            <p className="mt-1 text-xs text-gray-400">JPG or PNG, minimum 1200×400px</p>
          </FieldGroup>

          {bannerData.previewUrl ? (
            <img
              src={bannerData.previewUrl}
              alt="Preview"
              className="w-full rounded-xl border border-gray-200 object-cover max-h-44"
            />
          ) : (
            <div className="w-full rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 flex items-center justify-center max-h-44 h-44">
              <p className="text-xs text-gray-400">Preview will appear here</p>
            </div>
          )}
        </div>

        {/* Right — Schedule + Details + Submit */}
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-2 pb-3 border-b border-gray-100">
            <div className="w-7 h-7 rounded-lg bg-black flex items-center justify-center text-white flex-shrink-0">
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-sm font-semibold text-gray-800">Schedule & Details</h3>
          </div>

          <FieldGroup label="Start Date & Time">
            <input
              type="datetime-local"
              value={bannerData.startDate}
              onChange={(e) => handleChange("startDate", e.target.value)}
              className={inputClass}
            />
          </FieldGroup>

          <FieldGroup label="End Date & Time">
            <input
              type="datetime-local"
              value={bannerData.endDate}
              onChange={(e) => handleChange("endDate", e.target.value)}
              className={inputClass}
            />
          </FieldGroup>

          <FieldGroup label="Description">
            <input
              type="text"
              value={bannerData.description}
              onChange={(e) => handleChange("description", e.target.value)}
              placeholder="Enter a short banner description"
              className={inputClass}
            />
          </FieldGroup>

          <ProductSearchDropdown
            productSearch={productSearch}
            productResults={productResults}
            loadingProducts={loadingProducts}
            productId={bannerData.productId}
            onInputChange={handleProductInputChange}
            onSelect={handleSelectProduct}
          />

          <button
            type="submit"
            className="mt-auto bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-xl text-sm font-semibold active:scale-[0.98] transition-all duration-200 flex items-center gap-2 w-full justify-center"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            Create Banner
          </button>
        </div>

      </div>
    </form>
  </ShadowContainer>
);

export default BannerForm;
